import { useState, useEffect } from "react";
import "./News.css";
import NewsGridItem from "./NewsGridItem";

const NewsGrid = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchRSS = async () => {
      const rssUrl = "https://static.hng-group.com/category/news/feed/index.html"; 

      try {
        const response = await fetch(rssUrl);
        const text = await response.text();
        console.log(text);
        const parser = new DOMParser();
        const xml = parser.parseFromString(text, "application/xml");

        const items = xml.querySelectorAll("item");
        console.log(items);
        const articlesArray = Array.from(items).map((item) => ({
          title: item.querySelector("title").textContent,
          link: item.querySelector("link").textContent,
          description: "description is gone for the time being",
          pubDate: item.querySelector("pubDate")?.textContent || "No date",
          imageUrl: item.querySelector("enclosure")?.getAttribute("url") || "",
        }));

        setArticles(articlesArray);
      } catch (error) {
        console.error("Error fetching RSS feed:", error);
      }
    };

    fetchRSS();
  }, []);

  return (
    <div className="grid">
      {articles.length > 0 ? (
        articles.map((article, index) => (
          <NewsGridItem key={index} article={article} />
        ))
      ) : (
        <p className="loading-text">Loading news...</p>
      )}
    </div>
  );
};

export default NewsGrid;
